import InitialState from '../initial-state';
import * as ActionNames from '../action-names';

export default function reducer(
  state = InitialState.getState().favoritesStrip,
  { type, payload }
) {
  switch (type) {
    case ActionNames.SEARCH_FAVORITES_SUCCESS: {
      return {
        ...state,
        searchResults: payload
      };
    }
    case ActionNames.SEARCH_FAVORITES_FAILED: {
      return {
        ...state,
        searchResults: []
      };
    }
    case ActionNames.FAVORITES_VALIDATION_AND_INITIAL_DATA_LOAD_SUCCESS: {
      return {
        ...state,
        token: payload.favoriteToken,
        favorites: payload.initialData.favorites,
        settings: {
          comingSoon: payload.initialData.settings.comingSoon,
          endGame: payload.initialData.settings.endGame
        }
      };
    }
    case ActionNames.FAVORITES_VALIDATION_AND_INITIAL_DATA_LOAD_FAILED: {
      return {
        ...state,
        initialLoadFailed: true
      };
    }
    case ActionNames.FAVORITES_COMING_SOON_SUCCESS: {
      return {
        ...state,
        settings: payload.settings
      };
    }
    case ActionNames.FAVORITES_ENDGAME_SUCCESS: {
      return {
        ...state,
        settings: payload.settings
      };
    }
    case ActionNames.FOLLOW_FAVORITE_SUCCESS: {
      return {
        ...state,
        favorites: payload.favorites
      };
    }
    case ActionNames.UNFOLLOW_FAVORITE_SUCCESS: {
      return {
        ...state,
        favorites: payload.favorites
      };
    }
    default:
      return state;
  }
}
